module.exports = __webpack_public_path__ + "img/founder_new.e6be40db.svg";